import { useLocation } from "react-router";

import { Container, Link, PortalLayout, Stack, Typography } from "../../design-system";
import { withSignInRef } from "../../portal-auth";
import { checkEmailContent } from "./content";

/**
 * /sign-in/check-email (design state 1.2, AC-22, AC-29). Takes no props
 * and reads no outcome of its own -- there is nothing in this component's
 * inputs that COULD vary between a match, several matches, no match,
 * revoked access or a capped address, which is how "identical for every
 * sign-in outcome" holds structurally rather than by convention. It never
 * lists or counts renewals, and shows no resend action -- only a link back
 * to /sign-in, which keeps the renewal reference `?r=` when this view was
 * opened with one (ADR-20261102-k4rf). The reference comes from the URL,
 * never from the sign-in outcome, so the view stays identical per outcome.
 */
export function CheckEmailPage() {
  const { search } = useLocation();
  return (
    <PortalLayout headerVariant="entry" helpLine={checkEmailContent.helpLine} background="white">
      <Container layout="entry">
        <Stack gap="field">
          <Typography variant="display" as="h1">
            {checkEmailContent.heading}
          </Typography>
          <Typography variant="bodyLarge">{checkEmailContent.matchedStatement}</Typography>
          <Typography variant="bodyLarge">{checkEmailContent.linkValidityStatement}</Typography>
          <Stack gap="xs">
            <Typography variant="heading3" as="h2">
              {checkEmailContent.resendSubHeading}
            </Typography>
            <Typography variant="bodyLarge">
              {checkEmailContent.resendCheckStatement}{" "}
              <Link to={withSignInRef("/sign-in", search)}>{checkEmailContent.reenterEmailActionLabel}</Link>
            </Typography>
          </Stack>
        </Stack>
      </Container>
    </PortalLayout>
  );
}
